import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=6266afd0&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=6266afd0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6266afd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6266afd0')) {
      api.createRecord('6266afd0', component.options)
    } else {
      api.reload('6266afd0', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=6266afd0&scoped=true", function () {
      api.rerender('6266afd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/goodsManage/cardInventory/detail.vue"
export default component.exports